import { OcrCardViewModel } from '@diamond/sol-buyer/utils';

export const OCR_MAX_PROOF_FILES = 5;

export const getRemainingOcrFileSlots = (
  cardsLength: number,
  submittedProofsLength = 0
) => Math.max(OCR_MAX_PROOF_FILES - submittedProofsLength - cardsLength, 0);

export const isOcrUploadLoadingState = ({
  isAnalyzingOcr,
  isPollingTimedOut,
  isUploading,
}: {
  isAnalyzingOcr: boolean;
  isPollingTimedOut: boolean;
  isUploading: boolean;
}) => isUploading || (isAnalyzingOcr && !isPollingTimedOut);

export const getVisibleOcrCards = (
  cards: OcrCardViewModel[],
  isOcrUploadLoading: boolean
) =>
  isOcrUploadLoading
    ? cards.filter((card) => card.state !== 'analyzing')
    : cards;

export const getOcrManualFieldIndex = (
  visibleCards: OcrCardViewModel[],
  index: number,
  manualOverrides: Array<{ ocr_job_id?: string } | null | undefined>
) => {
  const card = visibleCards[index];
  const fallbackFieldIndex = visibleCards
    .slice(0, index)
    .filter(
      (item) =>
        item.state === 'manual_fallback' ||
        item.state === 'duplicate' ||
        item.state === 'success'
    ).length;
  const manualOverrideIndex = manualOverrides.findIndex(
    (override) => override?.ocr_job_id === card?.item.id
  );

  return manualOverrideIndex >= 0 ? manualOverrideIndex : fallbackFieldIndex;
};
